<template>
  <div class="main-content">
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <h2 class="mb-2">Dashboard</h2>
                <p class="text-muted mb-md-0">
                  {{ `Welcome ${fullname}` }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <div class="card-header-title">Summary Ideation</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4">
                <div class="card w-100 bg-info" @click="goToList('all')" style="cursor: pointer;">
                  <div class="card-body">
                    <div class="row align-items-center gx-0">
                      <div class="col">
                        <h6 class="text-uppercase text-body-secondary mb-2">All Ideation</h6>
                        <span class="h2 mb-0">{{ dataSummaryDashboard?.ideation?.totalIdeation }}</span>
                      </div>
                      <div class="col-auto">
                        <span class="h2 fe fe-book text-body-secondary mb-0"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->
              <div class="col-lg-4">
                <div class="card" @click="goToList('draft')" style="background-color: #e66b00 !important; cursor: pointer;">
                  <div class="card-body">
                    <div class="row align-items-center gx-0">
                      <div class="col">
                        <h6 class="text-uppercase text-body-secondary mb-2 ">Draft</h6>
                        <span class="h2 mb-0">{{ dataSummaryDashboard?.ideation?.totalIdeationDraft }}</span>
                      </div>
                      <div class="col-auto">
                        <span class="h2 fe fe-bookmark text-body-secondary mb-0"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->
              <div class="col-lg-4">
                <div class="card bg-success" @click="goToList('on_review')" style="cursor: pointer;">
                  <div class="card-body">
                    <div class="row align-items-center gx-0">
                      <div class="col">
                        <h6 class="text-uppercase text-body-secondary mb-2">On Review</h6>
                        <span class="h2 mb-0">{{ dataSummaryDashboard?.ideation?.totalIdeationReview }}</span>
                      </div>
                      <div class="col-auto">
                        <span class="h2 fe fe-eye text-body-secondary mb-0"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->
              <div class="col-lg-4">
                <div class="card bg-warning" @click="goToList('revision')" style="cursor: pointer;">
                  <div class="card-body">
                    <div class="row align-items-center gx-0">
                      <div class="col">
                        <h6 class="text-uppercase text-body-secondary mb-2">Revision Ideation</h6>
                        <span class="h2 mb-0">{{ dataSummaryDashboard?.ideation?.totalIdeationRevision }}</span>
                      </div>
                      <div class="col-auto">
                        <span class="h2 fe fe-rotate-ccw text-body-secondary mb-0"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->
              <div class="col-lg-4">
                <div class="card bg-secondary" @click="goToList('hold')" style="cursor: pointer;">
                  <div class="card-body">
                    <div class="row align-items-center gx-0">
                      <div class="col">
                        <h6 class="text-uppercase text-body-secondary mb-2 text-white">Hold</h6>
                        <span class="h2 mb-0 text-white">{{ dataSummaryDashboard?.ideation?.totalHoldIdeation }}</span>
                      </div>
                      <div class="col-auto">
                        <span class="h2 fe fe-pause text-body-secondary mb-0 text-white"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->
              <div class="col-lg-4">
                <div class="card bg-danger" @click="goToList('rejected')" style="cursor: pointer;">
                  <div class="card-body">
                    <div class="row align-items-center gx-0">
                      <div class="col">
                        <h6 class="text-uppercase text-body-secondary mb-2">Rejected</h6>
                        <span class="h2 mb-0">{{ dataSummaryDashboard?.ideation?.totalRejectedIdeation }}</span>
                      </div>
                      <div class="col-auto">
                        <span class="h2 fe fe-x text-body-secondary mb-0"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
        <div class="card">
          <div class="card-header">
            <div class="card-header-title">Summary Development</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4">
                <div style="position: relative; margin: auto; height: 300px; width: 100%;">
                <apexchart type="donut" height="300" :options="chartOptions" :series="series"></apexchart>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="card bg-success" @click="goToList('dso')" style="cursor: pointer;">
                  <div class="card-body">
                    <div class="row align-items-center gx-0">
                      <!-- Text Section -->
                      <div class="col d-flex flex-column justify-content-center">
                        <h6 class="text-uppercase mb-1">DSO</h6>
                        <span class="h2 mb-0">
                          {{ dataSummaryDashboard?.development?.totalDSO }}
                        </span>
                      </div>

                      <!-- Icon Section -->
                      <div class="col-auto d-flex align-items-center">
                        <span class="h2 fe fe-grid mb-0"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-lg-4">
                <div class="card bg-success">
                  <div class="card-body">
                    <div class="row align-items-center gx-0">
                      <div class="col">
                        <h6 class="text-uppercase text-body-secondary mb-2">Total Full Release</h6>
                        <span class="h2 mb-0">{{ dataSummaryDashboard?.development?.totalFullRelaseToDSO }}</span>
                      </div>
                      <div class="col-auto">
                        <span class="h2 fe fe-square text-body-secondary mb-0"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- CARDS -->

  </div>
</template>

<script>
  // import tableUser from '@/components/ideation/propose/tableUser.vue';
  // import Chart from "chart.js/auto";
  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "dashboard",
    components: {
      // tableUser
    },
    data() {
      const vm = this;
      return {
        company_id: "",
        fullname: "",
        company_name: "",
        body: {
          page: 1,
          limit: 10,
          type: 'DONE',
          order: "",
          ideation_name: "",
          // status: "DONE"
        },
        series: [],
          chartOptions: {
            chart: {
              type: 'donut',
              width: '10px',
              events: {
                click: function(event, chartContext, opts) {
                  let type = 'development'
                  vm.$store.commit('ideation/COMMIT_TYPE_IDEATION', type)
                  vm.$router.push(`/ideation`)
                }
              }
            },
            dataLabels: {
              enabled: true,
              formatter: function (val, opts) {
                // Get the original value from the series array
                const originalValue = opts.w.globals.series[opts.seriesIndex];
                return originalValue; // Or return a formatted value like "Value: " + originalValue
              }
            },
            colors: ['#00cf40', '#e66b00'],
            labels: [`Full Realese`, 'Partial Realese'],
            plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  fontFamily: 'Rubik',
                  color: '#dfsda',
                  // offsetY: -10
                },
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: undefined,
                  fontWeight: 800,
                  offsetY: 16,
                  formatter: function (val) {
                    return val
                  }
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#373d3f',
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                  }
                }
              }
            }
          }
        },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: '300px'
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
        columns: [{
            label: "IDEATION NAME",
            field: "ideation_name",
            thClass: "table-header no-wrap w-90 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "REQUESTOR NAME",
            field: "requestor.fullname",
            thClass: "table-header no-wrap w-90 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "DATE",
            field: "date",
            thClass: "table-header no-wrap w-90 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "CREATED BY",
            field: "createdByUser.fullname",
            thClass: "table-header no-wrap w-90 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "STATUS",
            field: "status",
            thClass: "table-header no-wrap w-90 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "ACTION",
            field: "action",
            thClass: "table-header no-wrap text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
        ],
      };
    },
    computed: {
      dataSummaryDashboard() {
        return this.$store.getters['ideation/summaryData'];
      },
      list() {
        return this.$store.getters["ideation/list"];
      },
    },
    mounted() {
      setTimeout(() => {
        this.company_id = localStorage.getItem("company");
        this.fullname = localStorage.getItem("fullname");
        this.company_name = localStorage.getItem("company_name");
        this.getSummaryData();
        // this.getList();
      }, 1500);
    },
    methods: {
      sorting() {
        this.getList();
      },
      getSummaryData() {
        this.$store.dispatch('ideation/GET_SUMMARY_DATA').then((resp) => {
          let data = this.$store.getters['ideation/summaryData'];
          this.series = [ data?.development?.totalFullRelaseToDSO || 0, data?.development?.totalPartialRelaseToDSO || 0];
        });
      },
      getList() {
        // this.body.type = ''; 
        // this.$store.dispatch("ideation/GET_LIST", this.body);
      },
      onPageChange(payload) {
        this.body.limit = payload.currentPerPage;
        this.body.page = payload.currentPage;
        this.getList();
      },
      goToList(type) {
        this.$store.commit('ideation/COMMIT_TYPE_IDEATION', type)
        this.$router.push(`/ideation`)
      }
    }
  };
</script>